import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form, FormGroup, Modal } from "react-bootstrap";
import {
  MdNavigateNext,
  MdNavigateBefore,
  MdAdd,
  MdClose,
} from "react-icons/md";
import FormValidator from "../../../../../shared/utils/FormValidator";
import { useStorage, useFunctions } from "reactfire";
import BarLoader from "react-spinners/BarLoader";
import Guidelines from "../../guidelines/Guidelines";
import randomString from "randomstring";
import AppFormCheck from "../../app-form-check/AppFormCheck";
import { AiOutlineFilePdf } from "react-icons/ai";
import { Country, TeamRole } from "../../../../../shared/constants/Constant";
import Application from "../../../../../database/models/application-form/malaysia/Application";
import TeamMember from "../../../../../database/models/application-form/malaysia/TeamMember";
import Alert from "../../../../../shared/components/alert/Alert";

// SidePanel

interface IState {
  isAgree: boolean;
  isAgreeError: string;
  teamName: string;
  teamNameError: string;
  projectName: string;
  sdg: ("SDG#3" | "SDG#9")[];
  sdgError: string;
  projectNameError: string;
  industry: string[];
  industryError: string;
  problem: string;
  problemError: string;
  howSolving: string;
  howSolvingError: string;
  whyImportant: string;
  whyImportantError: string;
  stage:
    | "Ideation"
    | "Idea Validated and Market Analysed"
    | "Business Plan Formulation"
    | "MVP launched"
    | "Early Revenue"
    | "Growth and Expansions";
  stageError: string;
  progress: string;
  progressError: string;
  proposal: any;
  proposalError: string;
  teamLeader: TeamMemberInApplication;
  teamMembersError: any;
  formStage: "TEAM_DATA" | "MEMBERS_DATA";
  loading: boolean;
  showGuidelines: boolean;
  hasError: boolean;
}

interface TeamMemberInApplication {
  fullName: string;
  fullNameError: string;
  email: string;
  emailAddressError: string;
  university: string;
  universityError: string;
  role: TeamRole;
  roleError: string;
  phone: string;
  countryCode: string;
  phoneError: string;
  state: string;
  stateError: string;
}

const initialState: IState = {
  isAgree: false,
  isAgreeError: "",
  teamName: "",
  teamNameError: "",
  projectName: "",
  projectNameError: "",
  industry: [],
  sdg: [],
  sdgError: "",
  industryError: "",
  problem: "",
  problemError: "",
  howSolving: "",
  howSolvingError: "",
  whyImportant: "",
  whyImportantError: "",
  stage: "Ideation",
  stageError: "",
  progress: "",
  progressError: "",
  proposal: null,
  proposalError: "",
  teamLeader: {
    email: "",
    emailAddressError: "",
    fullName: "",
    fullNameError: "",
    university: "",
    universityError: "",
    role: TeamRole.LEADER,
    roleError: "",
    state: "",
    countryCode: "",
    phoneError: "",
    phone: "",
    stateError: "",
  },
  teamMembersError: "",
  formStage: "TEAM_DATA",
  loading: false,
  showGuidelines: true,
  hasError: false,
};

const initialMember: TeamMemberInApplication = {
  email: "",
  emailAddressError: "",
  fullName: "",
  fullNameError: "",
  role: TeamRole.MEMBER,
  roleError: "",
  university: "",
  universityError: "",
  phone: "",
  countryCode: "",
  phoneError: "",
  state: "",
  stateError: "",
};

const initialMembers: TeamMemberInApplication[] = [initialMember];

interface IProps {
  onComplete(application: Application, fileName: string): void;
}

const ApplicationFormMalaysia = (props: IProps) => {
  const [state, setState] = useState(initialState);
  const [members, setMembers] = useState(initialMembers);
  // const [other, setOther] = useState({ value: "", checked: false, error: "" });
  const inup: any = null;
  const [uploader, setUploader] = useState(inup);
  const [upFileName, setUpFileName] = useState("");

  useEffect(() => {
    setState(initialState);
  }, []);

  //   const applicationRef = useFirestore().collection("applications");

  const validateTeamData = (): boolean => {
    const tnValidation = FormValidator.validateString(
      state.teamName,
      "Team/Company Name",
      3,
      100
    );

    const sdgValidation =
      state.sdg.length > 0
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Please select at least one option",
            isValid: false,
          };

    const aggValidation = state.isAgree
      ? {
          message: "",
          isValid: true,
        }
      : {
          message:
            "Please click 'Yes' after reading the competition rules and guidelines to be able to submit the application",
          isValid: false,
        };
    const prValidation = FormValidator.validateString(
      state.projectName,
      "Product/Project name",
      3,
      100
    );

    // const inValidation =
    //   state.industry.length === 0
    //     ? { message: "Industry is required.", isValid: false }
    //     : { message: "", isValid: true };

    // const otherValidation =
    //   other.value.length === 0
    //     ? { message: "Industry cannot be empty.", isValid: false }
    //     : { message: "", isValid: true };

    // const pbValidation = FormValidator.validateString(
    //   state.problem,
    //   "The answer",
    //   -1,
    //   1000
    // );

    // const slvValidation = FormValidator.validateString(
    //   state.howSolving,
    //   "The answer",
    //   -1,
    //   1000
    // );

    // const whyValidation = FormValidator.validateString(
    //   state.whyImportant,
    //   "The answer",
    //   -1,
    //   500
    // );

    const fileValidation =
      state.proposal === null
        ? { message: "Proposal is required.", isValid: false }
        : state.proposal?.type !== "application/pdf"
        ? { message: "Only pdf files are allowed.", isValid: false }
        : state.proposal.size > 105255200
        ? {
            message: "File size cannot be more than 100MB",
            isValid: false,
          }
        : { message: "", isValid: true };

    const stgValidation = FormValidator.validateString(
      state.stage,
      "The answer"
    );
    // const prgValidation = FormValidator.validateString(
    //   state.progress,
    //   "The answer",
    //   -1,
    //   1000
    // );

    // setOther({ ...other, error: otherValidation.message });
    setState({
      ...state,
      teamNameError: tnValidation.message,
      // industryError: inValidation.message,
      isAgreeError: aggValidation.message,
      proposalError: fileValidation.message,
      // problemError: pbValidation.message,
      // howSolvingError: slvValidation.message,
      projectNameError: prValidation.message,
      sdgError: sdgValidation.message,
      // whyImportantError: whyValidation.message,
      stageError: stgValidation.message,
      // progressError: prgValidation.message,
    });

    return (
      tnValidation.isValid &&
      aggValidation.isValid &&
      // (other.checked || inValidation.isValid) &&
      // pbValidation.isValid &&
      sdgValidation.isValid &&
      // slvValidation.isValid &&
      // (!other.checked || otherValidation.isValid) &&
      // whyValidation.isValid &&
      prValidation.isValid &&
      stgValidation.isValid &&
      fileValidation.isValid
      // prgValidation.isValid
    );
  };

  const validateMemberData = (): boolean => {
    const stValidation = FormValidator.validateString(
      state.teamLeader.state,
      "The state",
      -1,
      100
    );
    const fnValidation = FormValidator.validateString(
      state.teamLeader.fullName,
      "The full name",
      3,
      100
    );

    const pnValidation =
      state.teamLeader.phone && Number(state.teamLeader.phone)
        ? { message: "", isValid: true }
        : { message: "Phone Number is not valid", isValid: false };
    const ccValidation =
      state.teamLeader.countryCode && Number(state.teamLeader.countryCode)
        ? { message: "", isValid: true }
        : { message: "Phone Number is not valid", isValid: false };

    const memberEmails = members.map((member) => member.email);

    const emValidation = FormValidator.validateApplicationEmails(
      state.teamLeader.email,
      memberEmails
    );

    const unValidation = FormValidator.validateString(
      state.teamLeader.university,
      "University/Institute name",
      3,
      100
    );
    setState({
      ...state,
      teamLeader: {
        ...state.teamLeader,
        stateError: stValidation.message,
        phoneError: pnValidation.message || ccValidation.message,
        fullNameError: fnValidation.message,
        emailAddressError: emValidation.message,
        universityError: unValidation.message,
      },
    });

    return (
      stValidation.isValid &&
      fnValidation.isValid &&
      pnValidation.isValid &&
      ccValidation.isValid &&
      emValidation.isValid &&
      unValidation.isValid
    );
  };

  const validateTeamMembers = (): boolean => {
    return (
      members
        .map((member, index) => {
          const fnValidation = FormValidator.validateString(
            member.fullName,
            "The full name",
            3,
            100
          );
          const pnValidation =
            member.phone && Number(member.phone)
              ? { message: "", isValid: true }
              : { message: "Phone Number is not valid", isValid: false };
          const ccValidation =
            member.countryCode && Number(member.countryCode)
              ? { message: "", isValid: true }
              : { message: "Phone Number is not valid", isValid: false };

          const memberEmails = members
            .filter((memb, i) => index !== i)
            .map((mem) => mem.email);
          memberEmails.push(state.teamLeader.email);

          const emValidation = FormValidator.validateApplicationEmails(
            member.email,
            memberEmails
          );

          const unValidation = FormValidator.validateString(
            member.university,
            "University/Institute name",
            3,
            100
          );
          const rllValidation = FormValidator.validateString(
            member.role.toString(),
            "Roll"
          );
          const sttValidation = FormValidator.validateString(
            member.state,
            "The state",
            -1,
            100
          );

          members[index] = {
            ...member,
            fullNameError: fnValidation.message,
            emailAddressError: emValidation.message,
            universityError: unValidation.message,
            phoneError: ccValidation.message || pnValidation.message,
            roleError: rllValidation.message,
            stateError: sttValidation.message,
          };
          setMembers(Object.assign([], members));

          return (
            fnValidation.isValid &&
            emValidation.isValid &&
            pnValidation.isValid &&
            ccValidation.isValid &&
            unValidation.isValid &&
            sttValidation.isValid &&
            rllValidation.isValid
          );
        })
        .filter((b) => !b).length === 0
    );
  };

  const applicationRef = useFunctions().httpsCallable("submitApplication");
  const storageRef = useStorage().ref();
  // const [uploadPrograss, setUploadProgress] = useState(0);

  const validateAllData = (): boolean => {
    const a = validateTeamData();
    const b = validateMemberData();
    const c = validateTeamMembers();
    if (a && b && c) {
      return true;
    } else {
      setTimeout(() => {
        document
          .getElementsByClassName("invalid")
          .item(0)
          ?.parentElement?.scrollIntoView({
            behavior: "smooth",
          });
      }, 100);
      return false;
    }
  };

  const submitForm = () => {
    setState((ps) => ({ ...ps, loading: true }));
    const file: any = state.proposal;
    const uploadTask = storageRef
      .child(`proposals/${state.proposal?.name}`)
      .put(file);
    uploadTask.on(
      "state_changed",
      (snap) => {
        console.log(
          Math.round((snap.bytesTransferred / snap.totalBytes) * 100)
        );
      },
      (err) => {
        // alert("proposalLink upload error");
        // setState(initialState);
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          // const industries = Object.assign([], state.industry);
          // if (other.checked) industries.push(other.value);

          let teamMembersWithLeader = members.map(
            (tm): TeamMember => ({
              fullName: tm.fullName,
              email: tm.email,
              university: tm.university,
              state: tm.state,
              role: TeamRole[tm.role],
              phone: `+${tm.countryCode}${tm.phone}`,
              country: Country.MALAYSIA,
            })
          );

          teamMembersWithLeader.push({
            fullName: state.teamLeader.fullName,
            email: state.teamLeader.email,
            university: state.teamLeader.university,
            state: state.teamLeader.state,
            role: TeamRole[TeamRole.LEADER],
            phone: `+${state.teamLeader.countryCode}${state.teamLeader.phone}`,
            country: Country.MALAYSIA,
          });

          const applicationData: Application = {
            teamName: state.teamName,
            projectName: state.projectName,
            industries: ["devValue"],
            solvingProblem: "devValue",
            solvingApproach: "devValue",
            importance: "devValue",
            sdg: state.sdg,
            stage: state.stage,
            projectProgress: "devValue",
            proposalLink: url,
            members: teamMembersWithLeader,
            country: Country.MALAYSIA,
          };
          applicationRef(applicationData)
            .then((data) => {
              initialState.industry = [];
              setState({ ...initialState });
              initialMembers[0] = initialMember;
              setMembers(Object.assign([], initialMembers));
              const fileName = `${upFileName}`;
              setUpFileName("");
              props.onComplete(applicationData, fileName);
            })
            .catch((err) => {
              storageRef
                .child(`proposals/${state.proposal?.name}`)
                .delete()
                .then(() => {
                  //doto - handle this
                  console.log("File deleted successfully");
                })
                .catch(() => {
                  //doto - handle this
                  console.log("Uh-oh, an error occurred!");
                })
                .finally(() => {
                  setState({ ...state, loading: false, hasError: true });
                  setShow(false);
                });
            })
            .finally(() => {});
        });
      }
    );
  };

  const teamData = () => {
    return (
      <div>
        <FormGroup>
          <label className="font-weight-bold form-label">
            I have read, understood, and agree to the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://in.ieee.org/guidelines-malaysia"
            >
              competition rules and guidelines
            </a>
          </label>
          <fieldset id="group5">
            <div className="form-check">
              <input
                type="radio"
                checked={state.isAgree}
                name="group5"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    isAgree: e.target.checked,
                    isAgreeError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: true })}
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={!state.isAgree}
                className="form-check-input"
                name="group5"
                onChange={(e: any) =>
                  setState({ ...state, isAgree: !e.target.checked })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: false })}
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">{state.isAgreeError}</label>
          <input
            className={
              state.isAgreeError.length < 1 ? "d-none" : "d-none invalid"
            }
          />
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Team/Company Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.teamNameError.length < 1 ? "app-input" : "app-input invalid"
            }
            placeholder="Team/Company Name"
            value={state.teamName}
            onChange={(e) => {
              setState({
                ...state,
                teamName: e.target.value,
                teamNameError: "",
              });
            }}
          />
          <label className="error-message">{state.teamNameError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Which Sustainable Development Goals(SDG) theme are you considering?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <div className="form-check">
            <input
              type="checkbox"
              checked={state.sdg.includes("SDG#3")}
              className="form-check-input"
              onChange={(e: any) =>
                setState((ps) => {
                  if (ps.sdg.includes("SDG#3")) {
                    if (!e.target.checked) {
                      ps.sdg = ps.sdg.filter((s) => s !== "SDG#3");
                    }
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  } else {
                    ps.sdg.push("SDG#3");
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  }
                })
              }
            />
            <label
              className="form-check-label"
              onClick={(e: any) =>
                setState((ps) => {
                  if (ps.sdg.includes("SDG#3")) {
                    if (!e.target.checked) {
                      ps.sdg = ps.sdg.filter((s) => s !== "SDG#3");
                    }
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  } else {
                    ps.sdg.push("SDG#3");
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  }
                })
              }
            >
              SDG#3
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              checked={state.sdg.includes("SDG#9")}
              className="form-check-input"
              onChange={(e) =>
                setState((ps) => {
                  if (ps.sdg.includes("SDG#9")) {
                    if (!e.target.checked) {
                      ps.sdg = ps.sdg.filter((s) => s !== "SDG#9");
                    }
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  } else {
                    ps.sdg.push("SDG#9");
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  }
                })
              }
            />
            <label
              className="form-check-label"
              onClick={(e: any) =>
                setState((ps) => {
                  if (ps.sdg.includes("SDG#9")) {
                    if (!e.target.checked) {
                      ps.sdg = ps.sdg.filter((s) => s !== "SDG#9");
                    }
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  } else {
                    ps.sdg.push("SDG#9");
                    return { ...ps, sdg: [...ps.sdg], sdgError: "" };
                  }
                })
              }
            >
              SDG#9
            </label>
          </div>
          <label className="error-message">{state.sdgError}</label>
          <input
            className={
              state.isAgreeError.length < 1 ? "d-none" : "d-none invalid"
            }
          />
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Product/Project Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.projectNameError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Product/Project Name"
            value={state.projectName}
            onChange={(e) => {
              setState({
                ...state,
                projectName: e.target.value,
                projectNameError: "",
              });
            }}
          />
          <label className="error-message">{state.projectNameError}</label>
        </FormGroup>
        {/* <FormGroup>
          <label className="font-weight-bold form-label">
            What industry does your product/project fall under?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.industryError.length < 1 ? "d-none" : "d-none invalid"
            }
          />

          <AppFormCheck
            type="checkbox"
            label="Agriculture"
            checked={
              state.industry.filter((s) => s === "Agriculture").length > 0
            }
            onChange={(e: boolean) => {
              if (e) {
                state.industry.push("Agriculture");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Agriculture"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="ECommerce"
            checked={state.industry.filter((s) => s === "ECommerce").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("ECommerce");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "ECommerce"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="EdTech"
            checked={state.industry.filter((s) => s === "EdTech").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("EdTech");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "EdTech"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <Form.Check
            className="d-none"
            type="checkbox"
            label="Education"
            checked={state.industry.filter((s) => s === "Education").length > 0}
            onChange={(e: any) => {
              if (e.target.checked) {
                state.industry.push("Education");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Education"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="FinTech"
            checked={state.industry.filter((s) => s === "FinTech").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("FinTech");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "FinTech"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Health"
            checked={state.industry.filter((s) => s === "Health").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Health");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Health"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Logistics"
            checked={state.industry.filter((s) => s === "Logistics").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Logistics");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Logistics"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Media/Branding"
            checked={
              state.industry.filter((s) => s === "Media/Branding").length > 0
            }
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Media/Branding");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Media/Branding"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Retail"
            checked={state.industry.filter((s) => s === "Retail").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Retail");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Retail"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Power"
            checked={state.industry.filter((s) => s === "Power").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Power");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Power"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Social"
            checked={state.industry.filter((s) => s === "Social").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Social");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Social"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Travel and Hospitality"
            checked={
              state.industry.filter((s) => s === "Travel and Hospitality")
                .length > 0
            }
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Travel and Hospitality");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Travel and Hospitality"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Robotics"
            checked={state.industry.filter((s) => s === "Robotics").length > 0}
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Robotics");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Robotics"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Information Sciences"
            checked={
              state.industry.filter((s) => s === "Information Sciences")
                .length > 0
            }
            onChange={(e: any) => {
              if (e) {
                state.industry.push("Information Sciences");
                setState({ ...state, industryError: "" });
              } else {
                const newInList = state.industry.filter(
                  (ind) => ind !== "Information Sciences"
                );
                setState({ ...state, industry: newInList });
              }
            }}
          />
          <AppFormCheck
            type="checkbox"
            label="Others"
            checked={other.checked}
            onChange={(e: any) => {
              if (e) {
                setOther({ ...other, checked: true });
              } else {
                setOther({ ...other, checked: false });
              }
            }}
          />
          {other.checked && (
            <>
              <input
                className="app-input"
                value={other.value}
                onChange={(e) => {
                  setOther({ ...other, value: e.target.value });
                  setState({ ...state, industryError: "" });
                }}
              />
              <label className="error-message">{other.error}</label>
            </>
          )}

          {!other.checked && (
            <label className="error-message">{state.industryError}</label>
          )}
        </FormGroup> */}
        {/* <FormGroup>
          <label className="font-weight-bold form-label">
            What is the problem you are solving?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
            <br />
            <span className="font-weight-normal" style={{ fontSize: "12px" }}>
              Max 1000 characters
            </span>
          </label>
          <textarea
            className={
              state.problemError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.problem}
            placeholder="Your Answer"
            onChange={(e) => {
              setState({ ...state, problem: e.target.value, problemError: "" });
            }}
          />
          <label className="error-message">{state.problemError}</label>
        </FormGroup> */}
        {/* <FormGroup>
          <label className="font-weight-bold form-label">
            How are you solving the problem?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <p style={{ fontSize: "12px" }}>
            Keep it short, snappy and to the point but remember to actually tell
            us what it is that you do. If you don't have an idea yet then tell
            us about any problems or areas you're interested in working on. Max
            1000 characters
          </p>
          <textarea
            className={
              state.howSolvingError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.howSolving}
            placeholder="Your Answer"
            onChange={(e) => {
              setState({
                ...state,
                howSolving: e.target.value,
                howSolvingError: "",
              });
            }}
          />
          <label className="error-message">{state.howSolvingError}</label>
        </FormGroup> */}
        {/* <FormGroup>
          <label className="font-weight-bold form-label">
            Why is This important to you?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <p style={{ fontSize: "12px" }}>
            Explain why you're passionate about this idea, or this problem? Max
            500 characters
          </p>
          <textarea
            className={
              state.whyImportantError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.whyImportant}
            placeholder="Your Answer"
            onChange={(e) => {
              setState({
                ...state,
                whyImportant: e.target.value,
                whyImportantError: "",
              });
            }}
          />
          <label className="error-message">{state.whyImportantError}</label>
        </FormGroup> */}
        <FormGroup>
          <label className="font-weight-bold form-label">
            What stage are you at?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <fieldset id="group1">
            <AppFormCheck
              type="radio"
              label="Ideation"
              value="Ideation"
              name="group1"
              checked={state.stage === "Ideation"}
              onChange={(e: any) => {
                setState({ ...state, stage: "Ideation" });
              }}
            />

            <AppFormCheck
              type="radio"
              label="Business plan formulation"
              value="Business Plan Formulation"
              name="group1"
              checked={state.stage === "Business Plan Formulation"}
              onChange={(e: any) => {
                setState({ ...state, stage: "Business Plan Formulation" });
              }}
            />
            <AppFormCheck
              type="radio"
              label="Idea validated and market analyzed"
              value="Idea Validated and Market Analysed"
              name="group1"
              checked={state.stage === "Idea Validated and Market Analysed"}
              onChange={(e: any) => {
                setState({
                  ...state,
                  stage: "Idea Validated and Market Analysed",
                });
              }}
            />
            <AppFormCheck
              type="radio"
              label="MVP launched"
              value="MVP launched"
              name="group1"
              checked={state.stage === "MVP launched"}
              onChange={(e: any) => {
                setState({ ...state, stage: "MVP launched" });
              }}
            />
            <AppFormCheck
              type="radio"
              label="Early revenue"
              value="Early Revenue"
              name="group1"
              checked={state.stage === "Early Revenue"}
              onChange={(e: any) => {
                setState({ ...state, stage: "Early Revenue" });
              }}
            />
            <AppFormCheck
              type="radio"
              label="Growth and expansion"
              value="Growth and Expansions"
              name="group1"
              checked={state.stage === "Growth and Expansions"}
              onChange={(e: any) => {
                setState({ ...state, stage: "Growth and Expansions" });
              }}
            />
          </fieldset>
          <label className="error-message">{state.stageError}</label>
        </FormGroup>
        {/* <FormGroup>
          <label className="font-weight-bold form-label">
            What is the progress you have made so far?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <p style={{ fontSize: "12px" }}>
            Have you already talked to some customers? Mocked up some
            wireframes? Or are you still in the dreaming it all up stage?
          </p>
          <textarea
            className={
              state.progressError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.progress}
            placeholder="Your Answer"
            onChange={(e) => {
              setState({
                ...state,
                progress: e.target.value,
                progressError: "",
              });
            }}
          />
          <label className="error-message">{state.progressError}</label>
        </FormGroup> */}
        <FormGroup>
          <label className="font-weight-bold form-label">
            Proposal Submission
          </label>
          <p style={{ fontSize: "14px" }}>
            To participate in the competition, participants must submit a
            proposal outlining their idea, accompanied by information about the
            participants. The proposal must comply with the{" "}
            <a
              href="http://in.ieee.org/guidelines-malaysia"
              rel="noopener noreferrer"
              target={"_blank"}
            >
              competition rules and guidelines
            </a>
            . You may use the{" "}
            <a
              href="https://docs.google.com/document/d/1ZjUo_gydNn5luW0ngJWxJnAINjwSMrzUInK28d8lB8s/edit?usp=sharing"
              rel="noopener noreferrer"
              target={"_blank"}
            >
              proposal template
            </a>{" "}
            to prepare the proposal.
          </p>
          {/* <p style={{ fontSize: "14px" }}>
            In addition to that, a 10 minute (max) video should be submitted
            together with the proposalLink outlining the idea. Judging will be based
            on the idea conveyed on the video and not on the quality of
            production.
          </p> */}
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Upload Project Proposal. (File must not exceed 100MB and must be in
            PDF format)
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <br />
          <input
            className="d-none"
            type="file"
            accept=".pdf"
            ref={(ref) => setUploader(ref)}
            onChange={(e) => {
              const file = e.target.files && e.target.files[0];
              if (file !== null) {
                setUpFileName(file?.name);
                const blob = file?.slice(0, file.size, file?.type);
                const newFile = new File(
                  [blob],
                  `${randomString.generate()}.${file?.name.split(".").pop()}`,
                  { type: file?.type }
                );
                if (file?.type !== "application/pdf") {
                  setState({
                    ...state,
                    proposal: newFile,
                    proposalError: "Only pdf files are allowed.",
                  });
                } else if (file?.size > 105255200) {
                  setState({
                    ...state,
                    proposal: newFile,
                    proposalError: "File size cannot be more than 100MB",
                  });
                } else {
                  setState({ ...state, proposal: newFile, proposalError: "" });
                }
              }
              e.target.value = "";
            }}
          />
          {upFileName.length > 0 ? (
            <div className="uploaded-file animated fadeIn">
              <span>
                <AiOutlineFilePdf />
              </span>
              <span className="mx-2">{upFileName}</span>
              <span className="remove-file">
                <MdClose
                  onClick={() => {
                    setUpFileName("");
                    setState({ ...state, proposal: null, problemError: "" });
                  }}
                />
              </span>
            </div>
          ) : (
            <button className="app-button" onClick={() => uploader.click()}>
              <span className="mr-2">
                <MdAdd style={{ transform: "scale(1.5) translateY(-2px)" }} />
              </span>
              Attach File
            </button>
          )}
          <br />
          <label className="error-message">{state.proposalError}</label>
        </FormGroup>
      </div>
    );
  };

  const teamMembers = () => {
    return (
      <div>
        {members.map((member, index) => (
          <div className="animated fadeIn" key={index}>
            <FormGroup>
              <label
                className="font-weight-bold form-label mr-2"
                style={{ fontSize: "large" }}
              >
                Team member {index + 1}
              </label>
              {index !== 0 && (
                <>
                  |
                  <label
                    className="link-label ml-2"
                    onClick={() => {
                      members.splice(index, 1);
                      setMembers(Object.assign([], members));
                    }}
                  >
                    remove
                  </label>
                </>
              )}
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Full Name
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.fullNameError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.fullName}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    fullName: e.target.value,
                    fullNameError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.fullNameError}</label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Email Address
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.emailAddressError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.email}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    email: e.target.value,
                    emailAddressError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">
                {member.emailAddressError}
              </label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Phone Number
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "28px",
                    fontWeight: "bold",
                  }}
                >
                  +
                </div>
                <input
                  className={
                    member.phoneError.length < 1
                      ? "app-input"
                      : "app-input invalid"
                  }
                  style={{ width: "70px", marginRight: "5px" }}
                  value={member.countryCode}
                  onChange={(e) => {
                    members[index] = {
                      ...member,
                      countryCode: e.target.value,
                      phoneError: "",
                    };
                    setMembers(Object.assign([], members));
                  }}
                />
                <input
                  className={
                    member.phoneError.length < 1
                      ? "app-input"
                      : "app-input invalid"
                  }
                  style={{ width: "200px" }}
                  value={member.phone}
                  onChange={(e) => {
                    members[index] = {
                      ...member,
                      phone: e.target.value,
                      phoneError: "",
                    };
                    setMembers(Object.assign([], members));
                  }}
                />
              </div>

              <label className="error-message">{member.phoneError}</label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Name of University/Institute
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <p style={{ fontSize: "12px" }}>
                Eg. Curtin Malaysia. Add N/A if you are a graduate
              </p>
              <input
                className={
                  member.universityError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.university}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    university: e.target.value,
                    universityError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.universityError}</label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                State
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.stateError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.state}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    state: e.target.value,
                    stateError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.stateError}</label>
            </FormGroup>
            <FormGroup className="d-none">
              <label className="font-weight-bold">
                Role in the team
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <fieldset id="group2">
                <Form.Check
                  type="radio"
                  label="Team member"
                  value="Team member"
                  name="group2"
                  checked={member.role === TeamRole.MEMBER}
                  onChange={(e: any) => {
                    members[index] = { ...member, role: TeamRole.MEMBER };
                    setMembers(Object.assign([], members));
                  }}
                />
                <Form.Check
                  type="radio"
                  label="Supervisor"
                  value="Supervisor"
                  name="group2"
                  checked={member.role === TeamRole.SUPERVISOR}
                  onChange={(e: any) => {
                    members[index] = { ...member, role: TeamRole.SUPERVISOR };
                    setMembers(Object.assign([], members));
                  }}
                />
              </fieldset>
              <label className="error-message">{member.roleError}</label>
            </FormGroup>
          </div>
        ))}
      </div>
    );
  };

  const teamMembersData = () => {
    return (
      <div>
        <>{teamMembers()}</>
        {members.length < 4 && (
          <FormGroup className="text-right">
            <button
              className="app-button"
              onClick={(e) => {
                members.push(initialMember);
                setMembers(Object.assign([], members));
              }}
            >
              <span className="mr-2">
                <MdAdd style={{ transform: "scale(1.5) translateY(-2px)" }} />
              </span>
              Add Member
            </button>
          </FormGroup>
        )}
      </div>
    );
  };

  const teamLeaderForm = () => {
    return (
      <div>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "larger" }}
          >
            Personal Info
          </label>
        </FormGroup>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "large" }}
          >
            Team Leader Details
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Full Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.teamLeader.fullNameError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.teamLeader.fullName}
            onChange={(e) => {
              setState({
                ...state,
                teamLeader: {
                  ...state.teamLeader,
                  fullName: e.target.value,
                  fullNameError: "",
                },
              });
            }}
          />
          <label className="error-message">
            {state.teamLeader.fullNameError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Email Address
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.teamLeader.emailAddressError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.teamLeader.email}
            onChange={(e) => {
              setState({
                ...state,
                teamLeader: {
                  ...state.teamLeader,
                  email: e.target.value,
                  emailAddressError: "",
                },
              });
            }}
          />
          <label className="error-message">
            {state.teamLeader.emailAddressError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Phone Number
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "28px",
                fontWeight: "bold",
              }}
            >
              +
            </div>
            <input
              className={
                state.teamLeader.phoneError.length < 1
                  ? "app-input"
                  : "app-input invalid"
              }
              style={{ width: "70px", marginRight: "5px" }}
              value={state.teamLeader.countryCode}
              onChange={(e) => {
                setState({
                  ...state,
                  teamLeader: {
                    ...state.teamLeader,
                    countryCode: e.target.value,
                    phoneError: "",
                  },
                });
              }}
            />
            <input
              className={
                state.teamLeader.phoneError.length < 1
                  ? "app-input"
                  : "app-input invalid"
              }
              style={{ width: "200px" }}
              value={state.teamLeader.phone}
              onChange={(e) => {
                setState({
                  ...state,
                  teamLeader: {
                    ...state.teamLeader,
                    phone: e.target.value,
                    phoneError: "",
                  },
                });
              }}
            />
          </div>

          <label className="error-message">{state.teamLeader.phoneError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Name of University/Institute
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <p style={{ fontSize: "12px" }}>
            Eg. Curtin Malaysia. Add N/A if you are a graduate
          </p>
          <input
            className={
              state.teamLeader.universityError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.teamLeader.university}
            onChange={(e) => {
              setState({
                ...state,
                teamLeader: {
                  ...state.teamLeader,
                  university: e.target.value,
                  universityError: "",
                },
              });
            }}
          />
          <label className="error-message">
            {state.teamLeader.universityError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            State
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.teamLeader.stateError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.teamLeader.state}
            onChange={(e) => {
              setState({
                ...state,
                teamLeader: {
                  ...state.teamLeader,
                  state: e.target.value,
                  stateError: "",
                },
              });
            }}
          />
          <label className="error-message">{state.teamLeader.stateError}</label>
        </FormGroup>
      </div>
    );
  };

  const membersData = () => {
    return (
      <>
        {teamLeaderForm()}
        {teamMembersData()}
      </>
    );
  };

  const [show, setShow] = useState(false);

  return (
    <Container fluid>
      <Row className="p-md-5">
        <Col xs={12}>
          <form
            onSubmit={(e: any) => {
              e.preventDefault();
            }}
          >
            {state.formStage === "TEAM_DATA" ? teamData() : membersData()}{" "}
            {state.hasError && (
              <FormGroup
                style={{ marginTop: "30px" }}
                className="d-flex justify-content-end"
              >
                <div style={{ width: "300px" }}>
                  <Alert
                    show={state.hasError}
                    onClose={() => setState({ ...state, hasError: false })}
                  >
                    Application submission failed
                  </Alert>
                </div>
              </FormGroup>
            )}
            <FormGroup className="text-right">
              {state.formStage === "MEMBERS_DATA" && !state.loading && (
                <button
                  className="mr-1 app-button"
                  onClick={() => {
                    setState({ ...state, formStage: "TEAM_DATA" });
                  }}
                >
                  <span className="mr-2">
                    <MdNavigateBefore
                      style={{ transform: "scale(2) translateY(-1px)" }}
                    />
                  </span>
                  Back
                </button>
              )}
              {state.loading ? (
                <button className="app-button" disabled>
                  {state.formStage === "TEAM_DATA" ? "Next" : "Submit"}
                </button>
              ) : (
                <button
                  className="app-button"
                  onClick={(e) => {
                    if (state.formStage === "TEAM_DATA") {
                      if (validateTeamData()) {
                        setState((ps) => ({
                          ...ps,
                          formStage: "MEMBERS_DATA",
                        }));
                      } else {
                        setTimeout(() => {
                          document
                            .getElementsByClassName("invalid")
                            .item(0)
                            ?.parentElement?.scrollIntoView({
                              behavior: "smooth",
                            });
                        }, 100);
                      }
                    } else {
                      if (validateAllData()) setShow(true);
                    }
                  }}
                >
                  {state.formStage === "TEAM_DATA" ? (
                    <>
                      Next
                      <span className="ml-2">
                        <MdNavigateNext
                          style={{ transform: "scale(2) translateY(-1px)" }}
                        />
                      </span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
            </FormGroup>
          </form>
        </Col>
      </Row>
      <Guidelines
        country={Country.MALAYSIA}
        show={state.showGuidelines}
        onHide={() => setState({ ...state, showGuidelines: false })}
      />
      <Modal centered show={show} onHide={() => {}}>
        <Modal.Body style={{ padding: "40px", paddingBottom: "10px" }}>
          <FormGroup>
            <h5>Are you sure you want to submit the application?</h5>
            <p className="text-justify">
              Once you submit the application, you will not be able to make any
              more changes.
            </p>
          </FormGroup>
          {state.loading && (
            <FormGroup className="mt-2" style={{ marginBottom: "30px" }}>
              <BarLoader
                height={4}
                width={"100%"}
                color={"#00629b"}
                loading={state.loading}
              />
            </FormGroup>
          )}

          <FormGroup className="text-right">
            {!state.loading && (
              <>
                <button
                  className="app-button mr-2"
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="app-button"
                  onClick={() => {
                    if (validateAllData()) submitForm();
                  }}
                >
                  Submit
                </button>
              </>
            )}
          </FormGroup>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ApplicationFormMalaysia;
